module.exports = __webpack_public_path__ + "static/media/logo.511a06eb.svg";